import { Rarity } from '@sorare/core/src/__generated__/globalTypes';

import {
  InventoryShardsTypePage,
  loader,
} from 'pages/inventory/InventoryShardsTypePage';

type Props = {
  type: Rarity;
};

export { loader };

export const EssenceTypePage = ({ type }: Props) => {
  return <InventoryShardsTypePage type={type} withPageHeader={false} />;
};
